import { AppdataService } from 'src/app/services/app-data/appdata.service';
import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { CommunicationInterfaceService } from '../communicationInterface/communication-interface.service';
import { SelectCameraComponent, SelectCameraModel } from 'src/app/features/livechat/select-camera/select-camera.component';
import { MatDialog } from '@angular/material/dialog';
import { GalleryComponent } from 'src/app/shared/gallery/gallery.component';

@Injectable({
  providedIn: 'root'
})

export class FormsService {
  annotateImage = new Subject<any>();
  closeDatePicker = new Subject<void>();
  appConfig: any;
  maskPlaceholder: string;
  showAnnotateContainer: boolean = false;
  annotationIndex!: number;
  activeAnnotateImage!: any;
  annotatedDataArray: any = [];
  audioRecordInterval: any = [];
  videoRecordInterval: any = [];
  isRecordingActive: boolean = false;
  isWebcamActive: boolean = false;

  annotateImageObservable: Observable<any> = this.annotateImage.asObservable();
  closeDatePickerObservable: Observable<any> = this.closeDatePicker.asObservable();

  constructor(private appdataService: AppdataService, private dialog: MatDialog, private commInterface: CommunicationInterfaceService) {
    appdataService.appConfigSub.subscribe((configData: any) => {
      this.appConfig = configData;
      this.maskPlaceholder = this.appConfig?.FormComponent?.masking?.maskPlaceholder
        ? this.appConfig?.FormComponent?.masking?.maskPlaceholder
        : '✺';
    });
  }

  setConfig() {
    this.appConfig = this.appdataService.getConfig();
    this.maskPlaceholder = this.appConfig?.FormComponent?.masking?.maskPlaceholder
    ? this.appConfig?.FormComponent?.masking?.maskPlaceholder
    : '✺';
  }

  maskFirstDigit(value, maskCharacter, count){
    return maskCharacter.repeat(count) + value.slice(count, value.length)
  }

  maskLastDigit(value, maskCharacter, count){
    return value.slice(0, -count) + maskCharacter.repeat(count)
  }

  maskDigitUsingPosition(value, pos1, pos2, maskCharacter){
    if(this.appConfig?.FormComponent?.masking?.enableZeroBased){
      if(this.appConfig?.FormComponent?.masking?.maskByCount)
        return value.substring(0, pos1) + maskCharacter.repeat(pos2) + value.substring(pos1 + pos2, value.length);
      else
        return value.substring(0, pos1) + maskCharacter.repeat(pos2 - pos1 + 1) + value.substring(pos2 + 1, value.length);
    }else{
      if(this.appConfig?.FormComponent?.masking?.maskByCount)
        return value.substring(0, pos1 - 1) + maskCharacter.repeat(pos2) + value.substring(pos1 + pos2 - 1, value.length);
      else
        return value.substring(0, pos1 - 1) + maskCharacter.repeat(pos2 - pos1 + 1) + value.substring(pos2, value.length);
    }
  }

  reverseMaskDigitUsingPosition(originalValue, maskedValue) {
    const maskedChars = maskedValue.split('');
    const originalChars = originalValue.split('');
    let finalReverseMaskedValue = '';

    maskedChars.forEach((letter: string, index: number) => {
      if(letter == '*') finalReverseMaskedValue+=originalChars[index];
      else finalReverseMaskedValue+='*';
    });
    
    return finalReverseMaskedValue;
  }

  maskingValue(data, pos, count) {
    if(!this.appConfig || !this.maskPlaceholder) this.setConfig();
    console.log(data);
    const defaultValue = data;
    let maskedValue: any;
    // ✺✹✌⚾
    switch(pos){
      case 'firstdigit':
        maskedValue = this.maskFirstDigit(defaultValue, this.maskPlaceholder, count).slice(0, data.length);
        break;
      case 'lastdigit':
      	maskedValue = this.maskLastDigit(defaultValue, this.maskPlaceholder, count).slice(0, data.length);
        break;
      case 'position':
        const positionArr = count.split(',');
        maskedValue = this.maskDigitUsingPosition(defaultValue, Number(positionArr[0]), Number(positionArr[1]), this.maskPlaceholder).slice(0, data.length);
    }
    return maskedValue;
  }

  reverseMaskingValue(data, pos, count) {
    if(!this.appConfig || !this.maskPlaceholder) this.setConfig();
    console.log(data);
    if(!data) return data;
    const defaultValue = data;
    let maskedValue: any;
    let modifiedCount = data.length > count ? (data.length - count) : 0;
    // ✺✹✌⚾
    switch (pos) {
      case 'firstdigit':
      	maskedValue = modifiedCount ? this.maskLastDigit(defaultValue, this.maskPlaceholder, modifiedCount).slice(0, data.length) : defaultValue;
        break;
      case 'lastdigit':
        maskedValue = modifiedCount ? this.maskFirstDigit(defaultValue, this.maskPlaceholder, modifiedCount).slice(0, data.length): defaultValue;
        break;
      case 'position':
        const positionArr = count.split(',');
        maskedValue = this.maskDigitUsingPosition(defaultValue, Number(positionArr[0]), Number(positionArr[1]), this.maskPlaceholder).slice(0, data.length);
        maskedValue = this.reverseMaskDigitUsingPosition(defaultValue, maskedValue);
        break;
    }
    return maskedValue;
  }

  /**
   * Method to handle confirm using Matdialog for user acceptance/rejection
   * @param title : Title for the dialog data
   * @param message : message for the dialog component
   * @param onClose : onclose event trigger
   */
  selectCamera(title: string, message: string, onClose) {
    try {
      return new Promise((resolve, reject) => {
        const dialogData = new SelectCameraModel(title, message);
        const dialogRef = this.dialog.open(SelectCameraComponent, {
          maxWidth: '400px',
          data: dialogData,
          disableClose: true
        });
        dialogRef.afterClosed().subscribe((dialogResult) => {
          onClose(dialogResult);
          resolve(dialogResult);
        });
      });
    } catch (error) {
      console.error('Exception in FormsService.selectCamera', error);
      this.commInterface.sendUIErrors('FormsService', 'selectCamera', JSON.stringify(error));
      this.commInterface.logToServer('error', 'FormsService.selectCamera', error);
    }
  }

  validateEntryMaxLength(formGroup: any, control: any, event: any, maxLength: any){
    formGroup.controls[control].setValue(event.target.value.substring(0, maxLength))
  }

  /**
   * Method to validate no leading spaces
   * @param regex: Regex in form of string
   * @returns null - incase of valid control value (or) { invalidValue: boolean } incase of invalid control value with respect to the regex
   */
  leadingSpacesValidator(): any {
    try {
      return (control: any) => {
        if (!control.value) return null;
        const isError = /^\s/.test(control.value);
        return !isError ? null : { invalidValue: true };
      };
    } catch (error) {
      console.error('%c Error occured while validating leading spaces - ', 'color: red', error);
      this.commInterface.sendUIErrors('FormsService', 'leadingSpacesValidator', error);
    }
  }

    /**
   * Method to preview images
   * @param imageSource Image url/source
   */
    onImagePreview(imageSource: any, name: string, time: string): void {
      try {
        this.dialog.open(GalleryComponent, {
          data: { imageSource: imageSource, name: name, time: time }
        });
      } catch (error) {
        console.error('%c Error Occured in onImagePreview', 'color: red', error);
        this.commInterface.sendUIErrors('FormsService', 'onImagePreview', JSON.stringify(error));
        this.commInterface.logToServer(
          'error',
          'Error occured in FormsService.onImagePreview',
          JSON.stringify(error)
        );
      }
    }
}
